'use client';

import NextButton from '@/components/Button/NextButton';
import GreenCheckIcon from '@/assets/icons/GreenCheckIcon';
import useModal from '@/hooks/useModal';
import { MODAL_NAMES } from '@/constants/modals';
import styles from './WarningModal.module.scss';

interface Props {
  url?: string;
}

const WarningModal = ({ url }: Props) => {
  const { removeModal } = useModal();
  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <h3 className={styles.title}>
          Heads up, this offer requires collateral
        </h3>
        <div className={styles.listWrapper}>
          <p className={styles.listTitle}>This might include:</p>
          <div className={styles.listItem}>
            <GreenCheckIcon className={styles.icon} />
            <span>A vehicle that you own</span>
          </div>
          <div className={styles.listItem}>
            <GreenCheckIcon className={styles.icon} />
            <span>Housing fixtures (e.g. appliances, flooring)</span>
          </div>
        </div>
      </div>
      <p className={styles.text}>
        Using collateral helps your approval chances or secure a lower APR. Are
        you sure you want to continue?
      </p>
      <div className={styles.buttonsWrapper}>
        <NextButton
          text="Yes, continue anyway"
          type="link"
          target="_blank"
          styles={styles.button}
          link={url}
        />
        <NextButton
          text="No, take me back"
          type="button"
          buttonType="button"
          styles={styles.button}
          variation="transparent"
          onClick={() => removeModal(MODAL_NAMES.securedOffer)}
        />
      </div>
    </div>
  );
};

export default WarningModal;
